'use strict';

var _ = require('lodash');
var DemandSharesTransformerFactory = function DemandSharesTransformerFactory(DataTransformer, momentService) {
  function DemandSharesTransformerFactory() {
    DataTransformer.call(this);
    this.sourceType = 'demand-shares-mode';
    this.priority = 1;
  }
  DemandSharesTransformerFactory.prototype = Object.create(DataTransformer.prototype);
  DemandSharesTransformerFactory.constructor = DemandSharesTransformerFactory;
  DemandSharesTransformerFactory.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  DemandSharesTransformerFactory.prototype.isCacheable = function () {
    return false;
  };
  DemandSharesTransformerFactory.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  DemandSharesTransformerFactory.prototype.transform = function (data) {
    var demandShares = data.domain.results;
    var result = [];
    var memoizedMomentOfDate = _.memoize(getMomentOfDate);
    for (var i = 0; i < demandShares.length; ++i) {
      var value = demandShares[i];
      var demandShare = {
        market: value.market,
        calibrationName: value.calibrationName,
        metric: value.metric,
        createdOn: memoizedMomentOfDate(value.createdOn, momentService.FIELD.CREATED_DATE),
        createdBy: value.createdBy,
        lastModifiedOn: value.lastModifiedOn ? memoizedMomentOfDate(value.lastModifiedOn, momentService.FIELD.LAST_UPDATED_AT) : undefined,
        lastModifiedBy: value.lastModifiedBy ? value.lastModifiedBy : undefined,
        calibrationStatus: value.calibrationStatus,
        assigned: value.assigned === 'Completed' ? value.assigned : undefined,
        active: value.assigned,
        startDate: memoizedMomentOfDate(value.startDate, momentService.FIELD.DEPARTURE_DATE),
        endDate: memoizedMomentOfDate(value.endDate, momentService.FIELD.DEPARTURE_DATE),
        fareBucket: value.fareBucket,
        travelTimeBucket: value.travelTimeBucketWidth,
        reviewStartDate: memoizedMomentOfDate(value.shareReviewStartDate, momentService.FIELD.DEPARTURE_DATE),
        reviewEndDate: memoizedMomentOfDate(value.shareReviewEndDate, momentService.FIELD.DEPARTURE_DATE),
        isolatedPublishDateTime: value.isolatedPublishDateTime
      };
      result.push(demandShare);
    }
    return result;
  };
  function getMomentOfDate(date, field, stringFormat) {
    return momentService.of(date, field, stringFormat);
  }
  return DemandSharesTransformerFactory;
};
DemandSharesTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = DemandSharesTransformerFactory;